import { chartSeriesColors } from "@/components/charts/seriesPalette"

/**
 * Color for the `index`-th of `total` compared groups — a distinct categorical
 * hue from the shared series palette (series identity, not a sequential ramp).
 * Wraps if there are more groups than palette colors.
 */
export function getPaletteColor(index: number, total: number): string {
  const colors = chartSeriesColors(Math.max(total, 1))
  const wrapped = ((index % colors.length) + colors.length) % colors.length
  return colors[wrapped]
}
